import React from 'react';
import styles from './RoleManagement.module.css';
import { formatDateTimeWithSeconds } from '../../utils/dateFormatter';

const RoleHistoryModal = ({ show, role, onClose }) => {
    if (!show || !role) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Role History</h2>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>
                <div className={styles.modalBody}>
                    <p><strong>Role:</strong> {role.name}</p>
                    <div className={styles.historyItem}>
                        <div className={styles.historyDate}>
                            {role.createdAt ? formatDateTimeWithSeconds(role.createdAt) : 'N/A'}
                        </div>
                        <div className={styles.historyAction}>
                            Role created {role.createdByName && `by ${role.createdByName}`}
                        </div>
                    </div>
                    {role.updatedAt && (
                        <div className={styles.historyItem}>
                            <div className={styles.historyDate}>
                                {formatDateTimeWithSeconds(role.updatedAt)}
                            </div>
                            <div className={styles.historyAction}>
                                Role updated {role.updatedByName && `by ${role.updatedByName}`}
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    <button className={styles.cancelButton} onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default RoleHistoryModal;